/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_JBP_PEER_COMPARISON = gql`
  query GetJBPPeerComparison($input: JBPReportInput!) {
    jbpPeerComparison(input: $input) {
      results {
        id
        name
        coldVaultCompliance
        auditQuestionCompliance
        combinedCompliance
        hierarchy
      }
      count
    }
  }
`
